import React  from 'react';
import BackButton from '../_Shared/BackButton';




function WorkingCapital() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="col-sm-10 mx-auto">
                    <BackButton /><h2 className="text-center">Working Capital</h2>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card text-white rounded formula-definition">
                                <div className="card-header text-center" id="formula">Formula Definition: Total current assets
                                (+ LIFO reserve, if recorded in asset portion of financial statement) minus total current liabilities.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}




export {
    WorkingCapital
}